module.exports = __webpack_public_path__ + "img/union-icon.e40897dc.svg";